import { SectionType } from '@common/models/sections';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AboutSliceType {
  sections?: Array<SectionType>;
  isFetching: boolean;
  isFetched: boolean;
  error: string;
}

const aboutSlice = createSlice({
  name: 'about',
  initialState: <AboutSliceType>{
    sections: null,
    isFetching: false,
    isFetched: false,
    error: '',
  },
  reducers: {
    fetchAboutRequest(state) {
      state.isFetching = true;
      state.isFetched = false;
      state.sections = null;
      state.error = '';
    },
    fetchAboutSuccess(state, { payload }: PayloadAction<Array<SectionType>>) {
      state.sections = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
    fetchAboutFailure(state, { payload }: PayloadAction<string>) {
      state.error = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
  },
});

export const { fetchAboutSuccess, fetchAboutRequest, fetchAboutFailure } = aboutSlice.actions;

export default aboutSlice.reducer;
